// extracted by mini-css-extract-plugin
export default {"txtname":"remove_txtname__iHuKk","modalBody":"remove_modalBody__jVufl","btn":"remove_btn__9F6mE"};